/**
 * ScrollLock Component
 */

import React, { useRef, FC } from 'react';
import { useLayoutEffect } from '../hooks/useIsomorphicLayoutEffect';
import { ScrollLockProps } from './scrollLock.types';
import { GlobalStyles } from './scrollLock.style';
import generateId from '../../utils/generateId';

export const CLASS_NAME_PREFIX = 'mlb-scroll-lock-'

const ScrollLock: FC<ScrollLockProps> = ({
  element = document?.body,
}: ScrollLockProps) => {

  const className = useRef(generateId(CLASS_NAME_PREFIX));

  useLayoutEffect(() => {

    if (!element) {
      return;
    }

    element.classList.add(className.current);

    return () => {

      element.classList.remove(className.current);

    };

  }, [element]);

  return element ? <GlobalStyles class={className.current} /> : null;

};

export default ScrollLock;
